export const HTTP_ERROR = "HTTP_ERROR";

export const httpError = err => ({
  type: HTTP_ERROR,
  error: err
});



// WEBPACK FOOTER //
// ./src/actions/error.js